<form [formGroup]="form">
  <pr-patient-relationship-selector
    placeholder="Primary Contact"
    [form]="form | map : getPrimaryContactCtrl"
   />
</form>
